var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32846 14.4771C7.53102 14.594 7.76079 14.6556 7.99468 14.6556C8.22858 14.6556 8.45835 14.594 8.66091 14.4771L13.3245 11.8122C13.5268 11.6953 13.6949 11.5273 13.8119 11.325C13.9288 11.1227 13.9905 10.8932 13.9907 10.6596V5.32979C13.9905 5.09612 13.9288 4.86663 13.8119 4.66433C13.6949 4.46204 13.5268 4.29405 13.3245 4.17722L8.66091 1.51232C8.45835 1.39537 8.22858 1.3338 7.99468 1.3338C7.76079 1.3338 7.53102 1.39537 7.32846 1.51232L2.66488 4.17722C2.46252 4.29405 2.29445 4.46204 2.17751 4.66433C2.06058 4.86663 1.9989 5.09612 1.99866 5.32979V10.6596C1.9989 10.8932 2.06058 11.1227 2.17751 11.325C2.29445 11.5273 2.46252 11.6953 2.66488 11.8122L7.32846 14.4771Z",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99469 14.6569V7.99469",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19189 4.66357L7.99471 7.9947L13.7975 4.66357",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9967 2.84479L10.9927 6.27585",
    stroke: "black",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.599ee291a6a55e42b146b17159d90edd.svg";
export { ForwardRef as ReactComponent };